import React from "react";
import { AlertCircle } from "lucide-react";
import Modal from "../../../../components/ui/Modal";
import { CustomVideoPlayer } from "../../../../components/video/CustomVideoPlayer";

interface SolutionVideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  question: any;
  questionIndex: number;
}

export default function SolutionVideoModal({ isOpen, onClose, question, questionIndex }: SolutionVideoModalProps) {
  const extractVimeoVideoId = (url: string): string | null => {
    if (!url) return null;
    const vimeoRegex = /(?:vimeo\.com\/(?:video\/)?|player\.vimeo\.com\/video\/)(\d+)/;
    const match = url.match(vimeoRegex);
    return match ? match[1] : null;
  };

  const getVimeoEmbedUrl = (url: string): string | null => {
    const videoId = extractVimeoVideoId(url);
    return videoId ? `https://player.vimeo.com/video/${videoId}` : null;
  };

  const getSolutionVideoUrl = () => {
    if (question?.metadata?.solutionVideoUrl) {
      return question.metadata.solutionVideoUrl;
    }
    if (question?.solutionMedia?.url) {
      return question.solutionMedia.url;
    }
    return null;
  };

  const isVimeoUrl = (url: string) => {
    return extractVimeoVideoId(url) !== null;
  };

  const solutionVideoUrl = getSolutionVideoUrl();

  if (!solutionVideoUrl) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Soru ${questionIndex + 1} - Çözüm Videosu`} size="xl" showCloseButton={true}>
      {/* Video Container */}
      <div className="aspect-video bg-black rounded-lg overflow-hidden">
        {isVimeoUrl(solutionVideoUrl) ? (
          <iframe
            src={getVimeoEmbedUrl(solutionVideoUrl) || ""}
            className="w-full h-full"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title={`Soru ${questionIndex + 1} Çözüm Videosu`}
          />
        ) : (
          <CustomVideoPlayer src={solutionVideoUrl} />
        )}
      </div>
    </Modal>
  );
}
